export const SUBDOMAINS = [
    'cancun'
    // 'ssp',
    // 'apozol',
    // 'apulco',
    // 'atolinga',
    // 'benitojuarez',
    // 'calera',
    // 'canitasfelipe',
    // 'chalchihuites',
    // 'concepcionoro',
    // 'cuauhtemoc',
    // 'plateadojoaquin',
    // 'salvador',
    // 'fresnillo',
    // 'genarocodina',
    // 'enriqueestrada',
    // 'franciscomurguia',
    // 'panfilonatera',
    // 'guadalupe',
    // 'huanusco',
    // 'jalpa',
    // 'jerez',
    // 'jimenezteul',
    // 'juanaldama',
    // 'juchipila',
    // 'loreto',
    // 'luismoya',
    // 'mazapil',
    // 'melchorocampo',
    // 'mezquitaloro',
    // 'miguelauza',
    // 'momax',
    // 'monteescobedo',
    // 'morelos',
    // 'moyahuaestrada',
    // 'nochistlanmejia',
    // 'noriaangeles',
    // 'ojocaliente',
    // 'panuco',
    // 'pinos',
    // 'riogrande',
    // 'sainalto',
    // 'santamaria',
    // 'sombrerete',
    // 'susticacan',
    // 'tabasco',
    // 'tepechitlan',
    // 'tepetongo',
    // 'teulgonzalez',
    // 'tlaltenangosanchez',
    // 'trancoso',
    // 'trinidadgarcia',
    // 'valparaiso',
    // 'vetagrande',
    // 'villacos',
    // 'villagarcia',
    // 'villagonzalez',
    // 'villahidalgo',
    // 'villanueva',
    // 'zacatecas',
    // 'policiainvestigacion',
    // 'mps',
    // 'peritos',
    // 'policiaestatal',
    // 'custodios',
    // 'policiavial',
    // 'goruz',
    // 'friz',
    // 'metrolpol'
];